import _implicitStylesheets from "./securityHeader.css";
import _implicitScopedStylesheets from "./securityHeader.scoped.css?scoped=true";
import _pageLink from "page/link";
import _c360Icon from "c360/icon";
import _appxProductIcons from "appx/productIcons";
import _appxProgressRing from "appx/progressRing";
import _c360Button from "c360/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a href="/"${"a0:title"} data-test-id="salesforce-logo"${3}><img${"a1:src"} width="50" height="35" class="logo${0}"${"a1:title"}${2}></a>`;
const $fragment2 = parseFragment`<div role="status" class="slds-spinner${0}"${2}><span class="slds-assistive-text${0}"${2}>${"t2"}</span><div class="slds-spinner__dot-a${0}"${2}></div><div class="slds-spinner__dot-b${0}"${2}></div></div>`;
const $fragment3 = parseFragment`<svg xmlns="http://www.w3.org/2000/svg" width="46px" height="32px" viewBox="0 0 46 32" class="icon-list${0}"${2}><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"${3}><path${"c2"} d="M35.5,27 C36.8807119,27 38,28.1192881 38,29.5 C38,30.8807119 36.8807119,32 
                                                        35.5,32 L2.5,32 C1.11928813,32 1.69088438e-16,30.8807119 0,29.5 C-1.69088438e-16,
                                                        28.1192881 1.11928813,27 2.5,27 L35.5,27 Z M42.1760013,18 C43.5567132,18 
                                                        44.6760013,19.1192881 44.6760013,20.5 C44.6760013,21.8807119 43.5567132,23 
                                                        42.1760013,23 L2.5,23 C1.11928813,23 -1.13669929e-12,21.8807119 -1.13686838e-12,
                                                        20.5 C-1.13703747e-12,19.1192881 1.11928813,18 2.5,18 L42.1760013,18 Z M43.5,9 
                                                        C44.8807119,9 46,10.1192881 46,11.5 C46,12.8807119 44.8807119,14 43.5,14 L2.5,14 
                                                        C1.11928813,14 1.69088438e-16,12.8807119 0,11.5 C-1.69088438e-16,10.1192881 1.11928813,
                                                        9 2.5,9 L43.5,9 Z M7.5,0 C8.88071187,-2.53632657e-16 10,1.11928813 10,2.5 C10,3.88071187 
                                                        8.88071187,5 7.5,5 L2.5,5 C1.11928813,5 1.69088438e-16,3.88071187 0,2.5 C-1.69088438e-16,
                                                        1.11928813 1.11928813,2.53632657e-16 2.5,0 L7.5,0 Z" fill-rule="nonzero"${2}/></g></svg>`;
const $fragment4 = parseFragment`<div class="review-details${0}"${2}><h1 class="review-name${0}" data-test-id="solutionName"${2}>${"t2"}</h1><span class="review-sub-name${0}"${2}>${"t4"}</span><dl${3}><div class="slds-pill${0}"${2}><dd${3}>${"t8"}</dd></div></dl></div>`;
const $fragment5 = parseFragment`<img width="49" height="54"${"a0:src"} class="illustration-bird${0}"${"a0:title"}${2}>`;
const $fragment6 = parseFragment`<hgroup${3}><h1${3}>${"t2"}</h1><h2${3}>${"t4"}</h2></hgroup>`;
const $fragment7 = parseFragment`<img width="144" height="180"${"a0:src"} class="illustration-tree${0}"${"a0:title"}${2}>`;
const stc0 = {
  classMap: {
    "srw-header": true
  },
  key: 0
};
const stc1 = {
  key: 1
};
const stc2 = {
  classMap: {
    "header": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "wrapper": true
  },
  key: 3
};
const stc4 = {
  classMap: {
    "slds-grid": true,
    "slds-var-p-horizontal_x-large": true
  },
  key: 4
};
const stc5 = {
  classMap: {
    "slds-size_1-of-5": true,
    "icon-and-back": true
  },
  key: 5
};
const stc6 = {
  key: 6
};
const stc7 = {
  key: 9
};
const stc8 = {
  "back-to-listings": true
};
const stc9 = {
  classMap: {
    "boot-strapper-button-icon": true
  },
  props: {
    "size": "x-small",
    "iconName": "utility:chevronleft"
  },
  key: 11
};
const stc10 = {
  classMap: {
    "slds-size_4-of-5": true
  },
  key: 12
};
const stc11 = {
  classMap: {
    "review-status": true
  },
  key: 15
};
const stc12 = {
  classMap: {
    "review-overview": true
  },
  key: 16
};
const stc13 = {
  classMap: {
    "review-icon": true
  },
  key: 17
};
const stc14 = {
  classMap: {
    "static-progress": true,
    "hidden": true
  },
  key: 22
};
const stc15 = {
  classMap: {
    "progress": true
  },
  key: 23
};
const stc16 = {
  classMap: {
    "review-actions": true
  },
  key: 27
};
const stc17 = {
  "data-test-id": "save-and-exit"
};
const stc18 = {
  key: 31
};
const stc19 = {
  classMap: {
    "wrapper": true
  },
  key: 33
};
const stc20 = {
  classMap: {
    "slds-grid": true,
    "slds-var-p-horizontal_x-large": true
  },
  key: 34
};
const stc21 = {
  classMap: {
    "padding-1/5": true,
    "slds-size_4-of-5": true
  },
  key: 35
};
const stc22 = {
  classMap: {
    "wayfinder-status": true
  },
  key: 36
};
const stc23 = {
  classMap: {
    "pin-spacer": true
  },
  key: 37
};
const stc24 = {
  classMap: {
    "progress": true,
    "floating-progress": true
  },
  key: 38
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {sp: api_static_part, st: api_static_fragment, c: api_custom_element, d: api_dynamic_text, t: api_text, h: api_element, ncls: api_normalize_class_name, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_element("header", stc1, [api_element("div", stc2, [api_element("div", stc3, [api_element("div", stc4, [api_element("div", stc5, [api_custom_element("page-link", _pageLink, stc6, [api_static_fragment($fragment1, 8, [api_static_part(0, {
    attrs: {
      "title": $cmp.sharedLabels.salesforceLogo
    }
  }, null), api_static_part(1, {
    attrs: {
      "src": $cmp.images.salesforceLogo,
      "title": $cmp.sharedLabels.salesforceLogo
    }
  }, null)])]), api_custom_element("page-link", _pageLink, stc7, [api_element("a", {
    classMap: stc8,
    attrs: {
      "href": "/solutions",
      "title": $cmp.sharedLabels.back,
      "data-test-id": "back-to-listings"
    },
    key: 10
  }, [api_custom_element("c360-icon", _c360Icon, stc9), api_text(api_dynamic_text($cmp.sharedLabels.back))])])]), api_element("div", stc10, [$cmp.isLoading ? api_static_fragment($fragment2, 14, [api_static_part(2, null, api_dynamic_text($cmp.sharedLabels.loading))]) : null, !$cmp.isLoading ? api_element("div", stc11, [api_element("div", stc12, [api_element("div", stc13, [api_element("div", {
    className: api_normalize_class_name($cmp.iconTypeClasses),
    key: 18
  }, [api_custom_element("appx-product-icons", _appxProductIcons, {
    props: {
      "type": $cmp.iconTemplate,
      "width": "26px",
      "height": "26px",
      "alternativeText": $cmp.solution.technology
    },
    key: 19
  })]), api_static_fragment($fragment3, 21, [api_static_part(2, {
    className: api_normalize_class_name($cmp.iconTemplate)
  }, null)])]), api_element("div", stc14, [api_element("div", stc15, [api_custom_element("appx-progress-ring", _appxProgressRing, {
    props: {
      "type": $cmp.solution.technology,
      "percentage": $cmp.percentageCompleted,
      "failed": $cmp.failed,
      "published": $cmp.pass
    },
    key: 24
  })])]), api_static_fragment($fragment4, 26, [api_static_part(2, null, api_dynamic_text($cmp.solutionName)), api_static_part(4, null, api_dynamic_text($cmp.solutionSubName)), api_static_part(8, null, api_dynamic_text($cmp.solutionType))])]), api_element("div", stc16, [api_custom_element("c360-button", _c360Button, {
    className: api_normalize_class_name($cmp.saveButton.class),
    attrs: stc17,
    props: {
      "label": $cmp.saveButton.label,
      "variant": $cmp.saveButton.variant,
      "iconName": $cmp.saveButton.iconName,
      "disabled": $cmp.saveButton.disabled
    },
    key: 28,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.saveButton.onclick))
    }
  }), api_static_fragment($fragment5, 30, [api_static_part(0, {
    attrs: {
      "src": $cmp.images.illustrationBird,
      "title": $cmp.sharedLabels.birdImage
    }
  }, null)])])]) : null])])])])])]), api_element("div", stc18, [api_element("div", {
    className: api_normalize_class_name($cmp.wayfinderClasses),
    key: 32
  }, [api_element("div", stc19, [api_element("div", stc20, [api_element("div", stc21, [!$cmp.isLoading ? api_element("div", stc22, [api_element("div", stc23, [api_element("div", stc24, [api_custom_element("appx-progress-ring", _appxProgressRing, {
    props: {
      "type": $cmp.solution.technology,
      "percentage": $cmp.percentageCompleted,
      "failed": $cmp.failed,
      "published": $cmp.pass
    },
    key: 39
  })])]), api_static_fragment($fragment6, 41, [api_static_part(2, null, api_dynamic_text($cmp.titleLabel)), api_static_part(4, null, api_dynamic_text($cmp.subtitleLabel))])]) : null])]), !$cmp.isLoading ? api_static_fragment($fragment7, 43, [api_static_part(0, {
    attrs: {
      "src": $cmp.images.illustrationTree,
      "title": $cmp.sharedLabels.treeImage
    }
  }, null)]) : null])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-lruh0f62dh";
tmpl.legacyStylesheetToken = "appx-securityHeader_securityHeader";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
